
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { ImageUploader } from "./ImageUploader";
import { validateNumericInput } from "./utilities/validateInput";
import { useState } from "react";

interface Step1Props {
  formData: {
    name: string;
    price: string;
    description: string;
    images: string[];
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
}

export const Step1BasicInfo = ({ formData, onChange, onNext }: Step1Props) => {
  const [priceError, setPriceError] = useState<string | null>(null);
  const canProceed = formData.name && formData.price && !priceError && formData.description && formData.images.length > 0;

  const handlePriceChange = (value: string) => {
    const error = validateNumericInput(value, 'price');
    setPriceError(error);
    onChange("price", value);
  };

  return (
    <div className="space-y-6 px-0">
      <div className="text-center space-y-3">
        <p className="text-[22px] text-black font-regular font-['Be_Vietnam_Pro']">
          Fill in the details below to create a new meal listing.
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2.5">
          <Label htmlFor="photos" className="text-black font-medium text-base">Photos *</Label>
          <ImageUploader
            images={formData.images}
            onImagesChange={(images) => onChange("images", images)}
          />
        </div>
      </div>

      <div className="space-y-2.5">
        <Label htmlFor="name" className="text-black font-medium text-base">Meal Name *</Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => onChange("name", e.target.value)}
          placeholder="Enter meal name"
          className="h-12 rounded-xl border-[#E5E5E5] focus:border-black focus:ring-black placeholder:text-[#6B7280] bg-[#EDEDED]"
          autoFocus={false}
          tabIndex={-1}
        />
      </div>

      <div className="space-y-2.5">
        <Label htmlFor="price" className="text-black font-medium text-base">Price ($) *</Label>
        <Input
          id="price"
          type="text"
          value={formData.price}
          onChange={(e) => handlePriceChange(e.target.value)}
          placeholder="0.00"
          className={`h-12 rounded-xl border-[#E5E5E5] focus:border-black focus:ring-black placeholder:text-[#6B7280] bg-[#EDEDED] ${
            priceError ? 'border-red-500 focus-visible:ring-red-500' : ''
          }`}
          autoFocus={false}
          tabIndex={-1}
        />
        {priceError && (
          <p className="text-sm text-red-500 mt-1">{priceError}</p>
        )}
      </div>

      <div className="space-y-2.5">
        <Label htmlFor="description" className="text-black font-medium text-base">Description *</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) => onChange("description", e.target.value)}
          placeholder="Describe your meal"
          className="min-h-[120px] rounded-xl border-[#E5E5E5] focus:border-black focus:ring-black placeholder:text-[#6B7280] bg-[#EDEDED]"
          autoFocus={false}
          tabIndex={-1}
        />
      </div>

      <div className="flex justify-end pt-4">
        <Button
          onClick={onNext}
          disabled={!canProceed}
          className="bg-black hover:bg-black/90 text-white px-8 py-3 h-12 rounded-full text-base font-medium transition-colors disabled:bg-[#E5E5E5]"
        >
          Next
        </Button>
      </div>
    </div>
  );
};
